"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.96 3.83v-1H1.04v1h2.41v1.33H1.04v1h4.84v1.33H1.04v1h2.41v1.33H1.04v1H5.5v1.33H1.04v1h13.92v-1h-2.7v-1.33h2.7v-1h-4.75V8.49h4.75v-1h-2.7V6.16h2.7v-1h-4.75V3.83h4.75Zm-3.7 8.33H6.5v-1.33h4.76v1.33ZM9.21 9.83H4.45V8.5h4.76v1.33Zm2.05-2.33H6.88V6.17h4.38V7.5ZM9.21 5.17H4.45V3.84h4.76v1.33Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.823 5.302V4.177H1.178v1.125H5.13v2.505H1.178v1.125h7.747v2.505H1.178v1.125H5.13v2.505H1.178v1.125h7.14v2.505h-7.14v1.125h21.645v-1.125h-4.41v-2.505h4.41v-1.125h-7.598v-2.505h7.598v-1.125h-4.41V8.932h4.41V7.807h-7.598V5.302h7.598Zm-5.535 13.395H9.443v-2.505h7.845v2.505Zm-3.188-3.63H6.255v-2.505H14.1v2.505Zm3.188-3.63H10.05V8.932h7.238v2.505ZM14.1 7.807H6.255V5.302H14.1v2.505Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.43 7.07v-1.5H1.57v1.5h5.27v3.34H1.57v1.5H11.9v3.34H1.57v1.5h5.27v3.34H1.57v1.5h9.52v3.34H1.57v1.5h28.86v-1.5h-5.88v-3.34h5.88v-1.5H20.3v-3.34h10.13v-1.5h-5.88v-3.34h5.88v-1.5H20.3V7.07h10.13Zm-7.38 17.86H12.59v-3.34h10.46v3.34Zm-4.25-4.84H8.34v-3.34H18.8v3.34Zm4.25-4.84H13.4v-3.34h9.65v3.34Zm-4.25-4.84H8.34V7.07H18.8v3.34Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.915 10.238V8.363H2.093v1.875h8.197v5.475H2.093v1.875h15.885v5.475H2.093v1.875h8.197v5.475H2.093v1.875h14.662v5.475H2.093v1.875h43.822v-1.875h-9.127v-5.475h9.127v-1.875H30.323v-5.475h15.592v-1.875h-9.127v-5.475h9.127v-1.875H30.323v-5.475h15.592ZM34.913 37.763H18.63v-5.475h16.283v5.475Zm-6.458-7.35H12.173v-5.475h16.282v5.475Zm6.458-7.35h-15.06v-5.475h15.06v5.475Zm-6.458-7.35H12.173v-5.475h16.282v5.475Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.22 13.65v-2.5H2.79v2.5h10.93v7.3H2.79v2.5h21.18v7.3H2.79v2.5h10.93v7.3H2.79v2.5h19.55v7.3H2.79v2.5h58.43v-2.5H49.05v-7.3h12.17v-2.5H40.43v-7.3h20.79v-2.5H49.05v-7.3h12.17v-2.5H40.43v-7.3h20.79Zm-14.67 36.7H24.84v-7.3h21.71v7.3Zm-8.61-9.8H16.23v-7.3h21.71v7.3Zm8.61-9.8H26.47v-7.3h20.08v7.3Zm-8.61-9.8H16.23v-7.3h21.71v7.3Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconExteriorWall = function IconExteriorWall(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Exterior Wall' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "ExteriorWall"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconExteriorWall.sizes = [16, 24, 32, 48, 64];
IconExteriorWall.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconExteriorWall;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/home/ExteriorWall.js
// module id = 2097
// module chunks = 0